import { z } from "zod";
import { DEFAULT_MEMBERSHIP_QUEUE_TAB, MEMBERSHIP_QUEUE_TABS } from "./constants";
import type { MembershipQueueTabId } from "./types";

const tabIds = MEMBERSHIP_QUEUE_TABS.map((tab) => tab.id) as [
  MembershipQueueTabId,
  ...MembershipQueueTabId[],
];

export const membershipRouteSearchSchema = z.object({
  queue: z.enum(tabIds).optional(),
  // Opens that member's detail drawer. Coerced and .catch-guarded like
  // usersSearchSchema: TanStack JSON-parses raw search values, so a numeric id
  // arrives as a number, and a thrown ZodError takes down the router's loader
  // pipeline rather than just ignoring a bad query string.
  userId: z.coerce.string().optional().catch(undefined),
});

export function resolveMembershipQueueTab(
  queue: MembershipQueueTabId | undefined,
): MembershipQueueTabId {
  if (!queue) return DEFAULT_MEMBERSHIP_QUEUE_TAB;
  return MEMBERSHIP_QUEUE_TABS.some((tab) => tab.id === queue)
    ? queue
    : DEFAULT_MEMBERSHIP_QUEUE_TAB;
}

export function membershipQueueSearch(
  queue: MembershipQueueTabId,
): { queue: MembershipQueueTabId } | Record<string, never> {
  return queue === "all" ? {} : { queue };
}
